(function () {
  'use strict';
  function init(root) {
    var headers = (root || document).querySelectorAll('.eb-header');
    headers.forEach(function (header) {
      var burger = header.querySelector('.eb-header__burger');
      var backdrop = header.querySelector('.eb-header__drawer-backdrop');
      var searchToggle = header.querySelector('.eb-header__search-toggle');

      function closeDrawer() {
        header.classList.remove('eb-header--drawer-open');
        if (burger) burger.setAttribute('aria-expanded', 'false');
      }
      if (burger) {
        burger.addEventListener('click', function () {
          var open = header.classList.toggle('eb-header--drawer-open');
          burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
      if (backdrop) backdrop.addEventListener('click', closeDrawer);

      if (searchToggle) {
        searchToggle.addEventListener('click', function () {
          header.classList.toggle('eb-header--search-open');
        });
      }

      var lastScroll = 0;
      window.addEventListener('scroll', function () {
        var main = header.querySelector('.eb-header__main');
        if (!main) return;
        if (window.scrollY > 8) {
          main.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)';
        } else {
          main.style.boxShadow = '';
        }
      }, { passive: true });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
